/**
 * @file Generic Button Component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatPriceForDisplay } from '../../util/format-money';
import Button from './Button';

const propTypes = {
  price: PropTypes.number,
  children: PropTypes.any,
  className: PropTypes.string,
};

const PricedButton = ({ price, children, className, ...props }) => {
  const classes = classNames({
    [className]: !!className,
    'btn-priced': true,
  });

  return (
    <Button {...props} className={classes}>
      <div className="btn-priced-content">{children}</div>
      <div className="btn-priced-price">
        <span>${formatPriceForDisplay(price)}</span>
      </div>
    </Button>
  );
};

PricedButton.propTypes = propTypes;

export default PricedButton;
